<div class="search-box me-2" ngbDropdown #searchDropdown="ngbDropdown">
  <img alt="search-icon" class="search-icon" [src]="(userPreferenceService.isDarkTheme$ | async) ? '/assets/icons/dark-search.svg' : '/assets/icons/search.svg'">
  <label for="search-bar-input" class="visually-hidden">{{placeholder}}</label>
  <input #searchInput
    id="search-bar-input"
    class="form-control"
    [(ngModel)]="SEARCH"
    (ngModelChange)="search()"
    [placeholder]="placeholder"
    (focus)="onFocus()"
    (blur)="onBlur()"
    />
  @if (isSearchInputFocused()) {
    <img
      class="reset-icon"
      src="assets/icons/times.svg"
      alt="Reset"
      (click)="resetSearch($event)"
      (keydown.enter)="resetSearch($event)"
      tabindex="0"
      />
  }
  @if (filteredList?.length > 0) {
    <div #dropdownContent class="custom-height" ngbDropdownMenu>
      @for (option of filteredList; track trackByFn($index, option)) {
        <ng-container *ngTemplateOutlet="optionTemplate;context:{'option': option}"></ng-container>
      }
    </div>
  }
</div>

<ng-template #optionTemplate let-option="option">
  <div class="option-container">
    <div class="d-flex align-items-center option"
      (click)="onSelectResult(option)"
      (keydown.enter)="onSelectResult(option)"
      tabindex="0"
      >
      <span class="option-label" [attr.data-mask]="dropdownItems?.maskData">{{ option?.label }}</span>
    </div>
  </div>
</ng-template>
